import React from 'react';
import DepartmentSubstancesList from './DepartmentSubstancesList';
import Edit from '../cruds/Edit';
import RemoteInputDualList from '../components/input/RemoteInputDualList';
import CopyFrom from '../components/input/CopyFrom';
import MainContainer from '../components/MainContainer';
import { Switch, Route } from 'react-router-dom';

const ENTITY_NAME = 'departmentActivities';
const ENTITY_ROUTE = 'departments/substances';

const CrudEdit = props => (
  <Edit {...props}
        overrideTitle="departmentSubstances.titleEdit"
        entityName={ENTITY_NAME}
        entityRoute={ENTITY_ROUTE}
        entityId={props.match.params.number + '/substances'}
  >
    <CopyFrom
        from="departmentActivities"
        order="DEPARTMENT_NAME"
        copyFrom="substances"
        optionValueName="id"
        optionLabelName={['departmentName', 'activityName']}
        valueName="value"
        param="activitySearch"
    />
    <RemoteInputDualList
        from="substances/simple?order=CODE"
        optionLabelName="code"
        name="value"
        label="departmentSubstances.value"
        vertical={true}
        canFilter
    />
  </Edit>
);

const Substances = props => {
  const basePath = props.match.url;
  return (
    <MainContainer>
      <Switch>
        <Route exact path={basePath} component={DepartmentSubstancesList} />
        <Route exact path={basePath + '/edit/:number'} render={props => <CrudEdit {...props} />} />
        <Route exact path={basePath + '/add'} render={props => <CrudEdit {...props} />} />
      </Switch>
    </MainContainer>
  );
};

export default Substances;



// WEBPACK FOOTER //
// ./src/main/pages/DepartmentSubstances.js